<template>
  <div class="flex">
    <vs-button
      v-if="isManager === true"
      color="danger"
      type="filled"
      icon-pack="feather"
      icon="icon-trash"
      @click="$emit('deletePopup')"
      class="mr-2">
      {{ $t('delete') }}
    </vs-button>
    <vs-button
      v-if="isManager === true"
      color="success"
      type="filled"
      icon-pack="feather"
      icon="icon-upload"
      @click="$emit('uploadExcelPopup')"
      class="mr-2">
      {{ $t('upload') }}
    </vs-button>
    <vs-button
      v-if="isManager === false && isStarted === false"
      color="success"
      type="filled"
      icon-pack="feather"
      icon="icon-play"
      @click="$emit('start')"
      class="mr-2"
    >
      <span v-text="$t('start')" class="m-0 p-0" />
    </vs-button>
    <vs-button
      v-if="isManager === false && isStarted === true"
      color="danger"
      type="filled"
      icon-pack="feather"
      icon="icon-pause"
      @click="$emit('stop')"
      class="mr-2"
    >
      <span v-text="$t('stop')" class="m-0 p-0" />
    </vs-button>
    <vs-button
      color="success"
      type="filled"
      icon-pack="feather"
      icon="icon-download"
      @click="$emit('exportExcelPopup')">
      {{ $t('download_and_reupload') }}
    </vs-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.AutoCallSystemPublic.TabNav',
  components: {
    NestedMenuTabButton
  },
  props: {
    isManager: {
      type: [Boolean],
      required: true
    },
    isStarted: {
      type: [Boolean],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
